import { render } from "./AdminDashboard.vue?vue&type=template&id=77ee30b4"
import script from "./AdminDashboard.vue?vue&type=script&lang=js"
export * from "./AdminDashboard.vue?vue&type=script&lang=js"

import exportComponent from "/Users/LeonardoMBP/Documents/GitHub/swagible-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__